module.exports = __webpack_public_path__ + "img/sns_instagram.7a49dbdc.png";